module.exports = __webpack_public_path__ + "static/media/banner.efe090ea.jpg";